import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectHouseStatus = ({ control }) => {

    const options = useMemo(() => {
        return [
            { value: 1, label: 'เช่าบ้านอยู่อาศัย' },
            { value: 2, label: 'ปลูกบ้านเองในที่เช่า' },
            { value: 3, label: 'บ้านและที่ดินของตนเอง' },
            { value: 4, label: 'อื่นๆ' }
        ]
    }, [])

    return (
        <Controller
            name="house_status"
            control={control}
            rules={{ required: true }}
            render={({ field }) => <Select options={options} placeholder="เลือก" {...field} isClearable />}
        />
    )
}

export default SelectHouseStatus
